"use strict";
exports.__esModule = true;
exports.uid = exports.shuffle = exports.draw = exports.random = void 0;
var array_1 = require("./array");
/**
 * Generates a random number between min and max
 */
var random = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
exports.random = random;
/**
 * Draw a random item from a list. Returns
 * null if the list is empty
 */
var draw = function (array) {
    var max = array.length;
    if (max === 0) {
        return null;
    }
    var index = (0, exports.random)(0, max - 1);
    return array[index];
};
exports.draw = draw;
var shuffle = function (array) {
    return array
        .map(function (a) { return ({ rand: Math.random(), value: a }); })
        .sort(function (a, b) { return a.rand - b.rand; })
        .map(function (a) { return a.value; });
};
exports.shuffle = shuffle;
var uid = function (length, specials) {
    if (specials === void 0) { specials = ''; }
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' + specials;
    return (0, array_1.iterate)(length, function (acc) {
        return acc + characters.charAt((0, exports.random)(0, characters.length - 1));
    }, '');
};
exports.uid = uid;
//# sourceMappingURL=random.js.map